import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#72757A"><path opacity=".4" d="M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334z" /><path d="M8 11.5a.5.5 0 01-.5-.5V7.953a.5.5 0 011 0V11a.5.5 0 01-.5.5zm.68-5.833A.666.666 0 008.013 5h-.006a.664.664 0 00-.664.667.67.67 0 00.67.666.667.667 0 00.667-.666z" /></g></svg>);